import { render, staticRenderFns } from "./hockTab.vue?vue&type=template&id=e941c546&scoped=true&"
import script from "./hockTab.vue?vue&type=script&lang=js&"
export * from "./hockTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e941c546",
  null
  
)

export default component.exports